import type { SupportedLocale } from '../i18n/i18n.no-deps'

export function displayDate(locale: SupportedLocale, date: Date, options?: Intl.DateTimeFormatOptions) {
    options = options || { dateStyle: 'medium' }
    return date.toLocaleString(locale, options)
}

export function startOfNextDay(): Date {
    const today = new Date()
    const tomorrow = new Date(today)
    // set date for tomorrow
    tomorrow.setDate(tomorrow.getDate() + 1)
    // set hours to be start of the day
    tomorrow.setHours(0, 0, 0, 0)

    return tomorrow
}

export function endOfNextDay(): Date {
    const today = new Date()
    const tomorrow = new Date(today)
    // set date for tomorrow
    tomorrow.setDate(tomorrow.getDate() + 1)
    // set hours to be end of the day
    tomorrow.setHours(23, 59, 59, 999)

    return tomorrow
}

export function setEndOfDay(date: Date): Date {
    const day = new Date(date)
    // set hours to be end of the day
    day.setHours(23, 59, 59, 999)
    return day
}

export function isValidDate(date: Date): boolean {
    if (date instanceof Date) {
        return !isNaN(date.getTime())
    }
    return false
}

export function isActionDueDateInPast(date: Date): boolean {
    const today = new Date()
    const inputDate = date
    return inputDate < today
}

export function secondsSinceUnixEpochForDate(date: Date): number {
    return date.getTime() / 1000.0
}

export function utcDate(
    year: number,
    month: number,
    day?: number,
    hours?: number,
    minutes?: number,
    seconds?: number,
    milliSeconds?: number
) {
    return new Date(Date.UTC(year, month, day ?? 0, hours ?? 0, minutes ?? 0, seconds ?? 0, milliSeconds ?? 0))
}

export function fallbackToDate0(date: Date | undefined): Date {
    return date ?? new Date(0)
}

export function toISOString(date: Date): string {
    return date.toISOString()
}

export function getEarliest(dates: Date[]): Date {
    return dates.reduce((earliest, date) => (earliest > date ? date : earliest), dates[0])
}

export function getLatest(dates: Date[]): Date {
    return dates.reduce((latest, date) => (latest < date ? date : latest), dates[0])
}
